import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataApi } from 'app/Model/dataApi';
import { EgresadoInterface, EmpleadoInterface } from 'app/Model/Oferta Academica/OfertaAcademica';
import { DataApiService } from 'app/services/data-api.service';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { MensajesHttpService } from 'app/utils/mensajesHttp/mensajes-http.service';
import { BehaviorSubject, EMPTY, Observable, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HomePageFacadeService {
  private responseEgresadoSource = new BehaviorSubject<EgresadoInterface[]>([]);
  private responseEmpleadoSource = new BehaviorSubject<EmpleadoInterface[]>([]);
  
  private Action$ = new Subject<any>();
  public responseAction$: Observable<any> = this.Action$.asObservable();

  private Cargando$ = new BehaviorSubject<boolean>(false);
  public responseCargando$: Observable<boolean> = this.Cargando$.asObservable();

  private Error$ = new BehaviorSubject<any>({ hasError: true, recurso: '', messageError: '', errors: [] });
  public responseError$: Observable<any> = this.Error$.asObservable();

  public Egresado$ = new BehaviorSubject<EgresadoInterface[]>([]);
  public responseEgresado$: Observable<EgresadoInterface[]>= this.Egresado$.asObservable();

  public Empleado$ = new BehaviorSubject<EmpleadoInterface[]>([]);
  public responseEmpleado$: Observable<EmpleadoInterface[]>= this.Egresado$.asObservable();
    
  private requisitoMaster$ = new BehaviorSubject<any[]>([]);
  public responserequisitoMaster$: Observable<any[]>= this.requisitoMaster$.asObservable();

  constructor(
    public _toast: ToastrServiceLocal, 
    public _dataApi: DataApiService,
    public _mensajesHttp: MensajesHttpService
  ) { }
  limpiarEgresado() {
    this.responseEgresadoSource.next([]); // Limpia los datos
  }
  limpiarEmpleado() {
    this.responseEmpleadoSource.next([]); // Limpia los datos
  }
  limpiarrequisitos() {
    this.requisitoMaster$.next([]); // Limpia los datos emitiendo un array vacío
  }
  mostrarEgresado(params: any): Observable<any> {
    this.Cargando$.next(true);

    return this._dataApi.PostDataApi(`solicitudes/egresado`, params).pipe(
        tap((result: DataApi | any) => {
          // this.PostGrado$.next(result.data.Table0);
            this.Egresado$.next(result.data.Table0);
            this.Cargando$.next(false);
        }),
        catchError((error: HttpErrorResponse) => {
            console.log(error);
            this._mensajesHttp.mostrarErrorHttp(
                error,
                'Ocurrió un error al mostrar los datos generales',
                ''
            );
            this.Cargando$.next(false);
            this.Error$.next({
                hasError: true,
                recurso: 'POST',
                messageError: this._mensajesHttp.mostrarErrorHttpString(
                    error,
                    'Ocurrió un error al mostrar la Solicitud Promoción'
                ),
                errors: [],
            });
            return EMPTY;
        })
    );
}

mostrarEmpleado(params: any): Observable<any> {
  this.Cargando$.next(true);

  return this._dataApi.PostDataApi(`solicitudes/solicitudEmpleado`, params).pipe(
      tap((result: DataApi | any) => {
        // this.PostGrado$.next(result.data.Table0);
          this.Egresado$.next(result.data.Table0);
          this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
          console.log(error);
          this._mensajesHttp.mostrarErrorHttp(
              error,
              'Ocurrió un error al mostrar los datos generales',
              ''
          );
          this.Cargando$.next(false);
          this.Error$.next({
              hasError: true,
              recurso: 'POST',
              messageError: this._mensajesHttp.mostrarErrorHttpString(
                  error,
                  'Ocurrió un error al mostrar la Solicitud Promoción'
              ),
              errors: [],
          });
          return EMPTY;
      })
  );
}

mostrarrequisitoMaster(params: any): Observable<any> {
  this.Cargando$.next(true);

  return this._dataApi.PostDataApi(`solicitudes/requisitosMaestria`, params).pipe(
      tap((result: DataApi | any) => {
        // this.PostGrado$.next(result.data.Table0);
          this.requisitoMaster$.next(result.data.Table0);
          this.Cargando$.next(false);
      }),
      catchError((error: HttpErrorResponse) => {
          console.log(error);
          this._mensajesHttp.mostrarErrorHttp(
              error,
              'Ocurrió un error al mostrar los datos generales',
              ''
          );
          this.Cargando$.next(false);
          this.Error$.next({
              hasError: true,
              recurso: 'POST',
              messageError: this._mensajesHttp.mostrarErrorHttpString(
                  error,
                  'Ocurrió un error al mostrar la Solicitud Promoción'
              ),
              errors: [],
          });
          return EMPTY;
      })
  );
}
}
